<template>
  <div class="text">
    <div class="text-center">
      <h2 class="title line center">Parteneri</h2>
    </div>
    <div class="text-center">
      <b-row cols="1" cols-sm="1" cols-md="3" cols-lg="3">
        <b-col>
          <a href="https://www.himalaya.ro/" target="_blank">
            <img :src="Himalaya" class="contact-partener" />
          </a>
        </b-col>

        <b-col>
          <a href="https://www.montrek.ro/" target="_blank">
            <img :src="Montrek" class="contact-partener" />
          </a>
        </b-col>
        <b-col>
          <a href="https://ihamac.ro/" target="_blank">
            <img :src="IHamac" class="contact-partener" />
          </a>
        </b-col>
        <b-col>
          <a href="https://vilabran.ro/" target="_blank">
            <img :src="ClubVilaBran" class="contact-partener img-invert" />
          </a>
        </b-col>
        <b-col>
          <a href="https://www.emag.ro/set-hamac-verde-brasov-trail-adventures-hammocks-0-4-kg-compact-300x150-cm-in-saculet-de-calatorie-btahammocks1/pd/DN3BCKBBM/?X-Search-Id=efe57e8b1a39245bd918&X-Product-Id=24373943&X-Search-Page=1&X-Search-Position=0&X-Section=search&X-MB=0&X-Search-Action=view" target="_blank">
            <img :src="Emag" class="contact-partener" />
          </a>
        </b-col>
        <b-col>
          <a href="https://www.proalpin.ro/" target="_blank">
            <img :src="Proalpin" class="contact-partener img-invert" />
          </a>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ClubVilaBran from "./../assets/clubvilabran.png";
import Emag from "./../assets/emag.png";
import Himalaya from "./../assets/himalaya.png";
import IHamac from "./../assets/ihamac.png";
import Montrek from "./../assets/montrek.jpg";
import Proalpin from "./../assets/proalpin.png";

export default {
  name: "Partners",

  computed: {
    ClubVilaBran() {
      return ClubVilaBran;
    },
    Emag() {
      return Emag;
    },
    Himalaya() {
      return Himalaya;
    },
    IHamac() {
      return IHamac;
    },
    Montrek() {
      return Montrek;
    },
    Proalpin() {
      return Proalpin;
    },
  },
};
</script>

<style>
.text {
  padding: 50px 0;
  text-align: center;
}

.text-center {
  text-align: center;
}

h2 {
  margin-top: 45px;
  color: #2f2911;
  text-transform: uppercase;
  position: relative;
  letter-spacing: 0;
  font-size: 26px;
  line-height: 40px;
  font-weight: 300;
}

h2.title.line {
  margin-top: 45px;
}

h2.title.line:after {
  position: absolute;
  content: "";
  display: block;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: -1;
  height: 40px;
  width: 2px;
  background-color: #0072bb;
  top: -50px;
}

.contact-partener {
  max-width: 100%;
  height: 40px;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  margin-bottom: 25px;
}

.img-invert {
  filter: invert(1);
}
</style>
